import css from "./aio.less";
import Icon from "../Icon";

interface Props {
    name: string
}

export default function AioIcon({name}: Props) {
    return <Icon className={css.icon} name={name}/>
}
